import { useMemo, type JSX } from "react";
import { Vector3 } from "three";
import { AnnotationShapeMesh } from "./annotation-shape-mesh";
import {
  AnnotationShape,
  useAnnotationShapesStore,
} from "./annotation-shapes-store";

/** @returns the shape being drawn, in the style it will have, also while the annotation form is open */
export function ShapeDraftRenderer(): JSX.Element | null {
  const draft = useAnnotationShapesStore((s) => s.draft);
  const hoverPoint = useAnnotationShapesStore((s) => s.hoverPoint);
  const style = useAnnotationShapesStore((s) => s.style);
  // Previews the closed shape when the next click closes it
  const canClose = useAnnotationShapesStore((s) => s.canClosePolygon);

  const isRectangle = draft?.shape === AnnotationShape.rectangle;

  const points = useMemo(() => {
    if (!draft) return [];
    const corners =
      draft.isClosed || isRectangle || canClose || !hoverPoint
        ? draft.points
        : [...draft.points, hoverPoint];
    return corners.map((p) => new Vector3(...p));
  }, [canClose, draft, hoverPoint, isRectangle]);

  if (!draft) return null;

  return (
    <AnnotationShapeMesh
      points={points}
      style={style}
      showCorners={!draft.isClosed && !isRectangle}
      isClosed={draft.isClosed || isRectangle || canClose}
    />
  );
}
